module.exports = __webpack_public_path__ + "img/s2P15.9a0a74af.png";